module.exports = __webpack_public_path__ + "static/media/twitterDark.bfc41f3c.svg";